import React, { useState } from 'react'
import ReportsApi from '../../../../api/ReportsApi'
import LineBarChart from 'components/LineBarChart'
import { IReportFilter } from 'views/Reports'
import { useThemeStyling } from 'hooks/useThemeStyling/useThemeStyling';
import { AccentArea } from 'components'

/**
 * @name ByNonUniqueCustomer
 * @desc Render Card Type chart
 * @filterValues IReportsFilter
 */
const ByNonUniqueCustomer = ({
    filterValues,
}: {
    filterValues: IReportFilter
}): React.ReactElement => {
    const { clientTheme } = useThemeStyling()
    const [loading, setLoading] = useState<boolean>(true)
    const [data, setData] = useState<
        { date: string; value: number; count: number }[]
    >([])

    React.useEffect(() => {
        setLoading(true)
        ReportsApi.getByNonUniqueCustomer(filterValues).then((data) => {
            setLoading(false)
            setData(data)
        })
    }, [filterValues]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <AccentArea title="Percentage of Chargebacks originating from non-unique customers">
            <LineBarChart
                data={data}
                loading={loading}
                barColor={
                    clientTheme.charts.lineBarCharts
                        .byNonUniqueCustomerLineBarChart.barColor
                }
                lineColor={
                    clientTheme.charts.lineBarCharts
                        .byNonUniqueCustomerLineBarChart.lineColor
                }
                leftYAxisLabel={'Ratio'}
                rightYAxisLabel={'Count'}
                leftYAxisPercent
            />
        </AccentArea>
    )
}

export default ByNonUniqueCustomer
